import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator/index';
import { withStyles, Chip } from '@material-ui/core';
import {
    SvgAirzoneIcon,
    SvgSDM18SP2Icon as SvgSensorIcon,
    SvgSDM18HCNIcon as SvgDriveElecIcon,
    SvgSDM17SPGIcon as SvgSmartPlugIcon,
    SvgSDM18HCLIcon as SvgHeatAndCoolIcon,
    SvgSDM18HCNIcon as SvgHomeConnectIcon,
    SvgSDM18MVRIcon as SvgVoletIcon,
    SvgSDM18HCNIcon as SvgSmartMeterIcon,
    SvgProduct
} from 'data/common/iconsvg/index';

class LogChipProductType extends PureComponent {
    static propTypes = {
        productType: PropTypes.string.isRequired,
        classes: PropTypes.object.isRequired,
        theme: PropTypes.object.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        const { theme } = this.props;
        this.state = {};
        this.productType = {
            airzone: <SvgAirzoneIcon size={15} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c010} />,
            zwave: <SvgProduct size={15} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c006} />,
            sensor: <SvgSensorIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c009} />,
            drive_elec: <SvgDriveElecIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />,
            smart_plug: <SvgSmartPlugIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c014} />,
            heat_and_cool: <SvgHeatAndCoolIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c007} />,
            home_connect: <SvgHomeConnectIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />,
            volet: <SvgVoletIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c012} />,
            smart_meter: <SvgSmartMeterIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />
        };
    }

    getDateFromType = () => {
        const { productType, theme } = this.props;
        switch (productType) {
            case 'airzone':
                return {
                    icon: <SvgAirzoneIcon size={15} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c010} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'zwave':
                return {
                    icon: <SvgProduct size={15} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c006} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'sensor':
                return {
                    icon: <SvgSensorIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c009} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'drive_elec':
                return {
                    icon: <SvgDriveElecIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'smart_plug':
                return {
                    icon: <SvgSmartPlugIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c014} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'heat_and_cool':
                return {
                    icon: <SvgHeatAndCoolIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c007} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'home_connect':
                return {
                    icon: <SvgHomeConnectIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'volet':
                return {
                    icon: <SvgVoletIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c012} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            case 'smart_meter':
                return {
                    icon: <SvgSmartMeterIcon size={20} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c011} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
            default:
                return {
                    icon: <SvgProduct size={15} color={theme.palette.common.white} secondaryColor={theme.palette.rainbow.c006} />,
                    label: Translator.translate(`general.products.productType.${productType}`)
                };
        }
    };

    render() {
        const { classes, productType } = this.props;
        const productObject = this.getDateFromType();
        return (
            <Chip
                size="small"
                icon={<div className={classes.chipIcon}>{productObject.icon}</div>}
                label={productObject.label}
                className={classes[productType]}
            />
        );
    }
}

const styles = theme => ({
    airzone: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c010
    },
    zwave: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c006
    },
    chipIcon: {
        color: theme.palette.common.white,
        marginLeft: 6,
        marginBottom: 1
    },
    volet: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c012
    },
    smart_meter: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c011
    },
    home_connect: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c008
    },
    heat_and_cool: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c007
    },
    smart_plug: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c014
    },
    drive_elec: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c011
    },
    sensor: {
        color: theme.palette.common.white,
        background: theme.palette.rainbow.c009
    }
});

export default withStyles(styles, { withTheme: true })(LogChipProductType);



// WEBPACK FOOTER //
// ./data/components/LogChipProductType.js